import { createFileRoute } from "@tanstack/react-router";
import OrganizationTransferPage from "@/pages/OrganizationTransferPage";

export const Route = createFileRoute("/transfer/$token")({
  component: OrganizationTransferPage,
});
